import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import taskValidator from './cannot-be-treated-validator'

export default createUIDefinition({
    taskName: taskName.CLARIFY_PRE_TREATMENT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.SENT_EMAIL_WIDGET,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator,
})




// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/clarify-pre-treatment.js